export const AGENCY_PAID_MAX_BRANDS = 5
export const FREE_AGENCY_MAX_BRANDS = 1
export const PRODUCT_MAX_BRANDS = 1
